import { createContext, useContext, useEffect, useState } from "react";
import { useFinderApi } from "./useFinderApi";
import { useAuth0 } from "@auth0/auth0-react";

const UserContext = createContext();

export function UserProvider({ children }) {
  const { getUserDetails, getNotificationPreferences } = useFinderApi();
  const { isAuthenticated } = useAuth0();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) return;
    setLoading(true);
    getUserDetails()
      .then(async (userData) => {
        if (userData && userData.id) {
          try {
            const preferences = await getNotificationPreferences(userData.id);
            setUser({ ...userData, preferences });
          } catch {
            setUser(userData);
          }
        } else {
          setUser(userData);
        }
      })
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, [isAuthenticated, getUserDetails, getNotificationPreferences]);

  return (
    <UserContext.Provider value={{ user, setUser, loading }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
